@if (snapshot) {
  <div data-qa="messages" fxFlex="66" fxLayout="column" fxLayoutAlign="space-around stretch">
    @if (snapshot.numberOfUnconfirmedNetzzuordnungen <= 0) {
      <span>Die letzten Änderungen der UUIDs wurden von Ihnen </span>
      <span>bestätigt am: {{snapshot.lastConfirmedUuidDate | date:'dd.MM.yyyy'}}
      um {{snapshot.lastConfirmedUuidDate | date:'HH:mm'}}</span>
    }
    @if (snapshot.numberOfUnconfirmedNetzzuordnungen > 0) {
      <p>Seit ihrer letzten Kenntnisnahme ({{snapshot.lastConfirmedUuidDate | date:'dd.MM.yyyy'}}
        um {{snapshot.lastConfirmedUuidDate | date:'HH:mm'}}) gibt
        es {{(snapshot.numberOfUnconfirmedNetzzuordnungen)}} neue/geänderte
        UUID's. Bitte bestätigen Sie Ihre Kenntnisname über den Kenntnisnahme-Button.
        Über den Button "Netzzuordnungen" können sie sich die neuen/geänderten UUID's anzeigen
        und exportieren lassen.
      </p>
      <div data-qa="link-confirm"><a
        (click)="updateLastUuidChangeConfirmDate()"
        matButton="filled">
        Zur Kenntnis genommen
      </a></div>
    }
  </div>
}
<div data-qa="link-netzzuordnungen" fxFlex="33" fxLayoutAlign="center center">
  <a
    (click)="routeToNetzzuordnungPage()"
    matButton="outlined">
    Netzzuordnungen
  </a>
</div>
